import type { CSSProperties } from 'react';
import type { Overlay } from '@vtf/shared';

/**
 * What public streams carry on top of the composed room (INT-STR-03): the K5 Trading mark, the presenter, the short
 * disclaimer along the bottom, and full-screen slates with the full disclaimer. Sized in container units, so the same
 * component draws the 1920×1080 egress page and the small preview in the backstage.
 */
export function EgressOverlay({ overlay, slate, className }: { overlay: Overlay; slate?: Overlay['slate'] | Overlay['startSlate']; className?: string }) {
  const u = (n: number): CSSProperties['fontSize'] => `${n}cqw`;
  const shown = slate ?? null;
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className ?? ''}`} style={{ containerType: 'inline-size' }} data-testid="egress-overlay">
      <div className="absolute flex items-center" style={{ top: '2.2cqw', left: '2.2cqw', gap: '0.8cqw' }}>
        <span className="grid place-items-center rounded font-mono font-bold text-[#0B0E12]" style={{ width: '3.4cqw', height: '3.4cqw', fontSize: u(1.5), background: '#e9c46a' }} aria-hidden>
          K5
        </span>
        <span className="rounded px-[0.8cqw] py-[0.3cqw] font-semibold text-white" style={{ fontSize: u(1.45), background: 'rgba(11,14,18,0.72)' }}>
          {overlay.brand}
        </span>
      </div>
      {overlay.lowerThird && (
        <div className="absolute flex flex-col rounded" style={{ left: '2.2cqw', bottom: overlay.ticker ? '5.4cqw' : '2.2cqw', padding: '0.6cqw 1.1cqw', background: 'rgba(11,14,18,0.78)', borderLeft: '0.35cqw solid #e9c46a', maxWidth: '55cqw' }}>
          <span className="font-semibold text-white" style={{ fontSize: u(1.6) }}>{overlay.lowerThird.name}</span>
          <span className="truncate text-[#c9d1db]" style={{ fontSize: u(1.15) }}>{overlay.lowerThird.title}</span>
        </div>
      )}
      {overlay.ticker && (
        <div className="absolute inset-x-0 bottom-0 text-center text-[#e7ebf0]" style={{ fontSize: u(1.05), padding: '0.8cqw 2cqw', background: 'rgba(11,14,18,0.86)' }} data-testid="egress-disclaimer">
          {overlay.ticker}
        </div>
      )}
      {shown && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white" style={{ background: '#0B0E12', padding: '6cqw 9cqw', gap: '1.6cqw' }} data-testid="egress-slate">
          <span className="font-semibold text-[#e9c46a]" style={{ fontSize: u(2.2) }}>{shown.heading}</span>
          <span className="font-bold" style={{ fontSize: u(3.4) }}>{shown.title}</span>
          <p className="m-0 leading-snug text-[#c9d1db]" style={{ fontSize: u(1.35), maxWidth: '78cqw' }}>{shown.body}</p>
          <span className="text-[#8b96a5]" style={{ fontSize: u(1.05) }}>{shown.operator}</span>
        </div>
      )}
    </div>
  );
}
